export default __webpack_public_path__ + "static/media/truth_but_funky.cbb4a99e.mp3";